<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fa fa-birthday-cake  text-primary"></i> Birthday</h5>
      </div>
      <hr>
      <div class="row g-3">
            <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.ClassId)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.ClassId = item._id"  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-3">
          <label for="inputclassname" class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" id="inputclass" v-model="Obj.Section">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name">
        </div>
        <div class="col-md-3">
          <label class="form-label">Date :</label>
          <input class="form-control form-control-sm cursor-pointer" role="button" type="date" v-model="Obj.dobDate" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Description :</label>
          <textarea class="form-control form-control-sm rounded" aria-label="With textarea" v-model="Obj.Description"></textarea>
        </div>
      <div class="col-md-3 mt-4">
          <label class="form-label">Photo
            <sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <label for="fileInput" class="attachment-icon-b">
            <i class="fa fa-upload fs-4 ms-1"></i>  <input
        type="checkbox"
        class="form-check-input ms-3"
        v-model="Obj.captureConsent"
        id="removeBg"
      />
      <label class="form-check-label mb-0" for="removeBg">
        Remove BG
      </label>
          </label>
         <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg ,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" /><br>
          <small class="form-text text-danger">Upload only jpg, jpeg and png files.</small>
          
          <div class="d-flex align-items-start">
            <a v-if="Obj.Image" :href="getUrl(Obj.Image)" target="_blank" class="clearfix">
              {{ Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1) }}
            </a>
            <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)"  class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
          </div>
        </div>
        <div class="col-md-6 mt-5 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save me-1"></i> Save</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
        </div>
           <div class="d-flex align-items-center gap-3 mt-2">
              <CapturePhoto  :autoStart="true"  :dwnloadfileName="'Birthday'">

              </CapturePhoto>

   </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-10 table-responsive mt-2">
            <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div> 
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import CapturePhoto from "@/components/Common/CapturePhoto.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import DataTable from "@/components/Common/DataTable.vue";
import { ref, onMounted} from 'vue'
import axios from 'axios';
 import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList} = schoolStore();
  const  Obj = ref(  { ClassId: "", Section: "", Name: "", dobDate: new Date().toISOString().slice(0, 10), Description: "", Image: "",captureConsent: false  })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
  { label: 'Birthday Date', key: 'Date'},
  { label: 'Class', key: 'Class'},
  { label: 'Photo', key: 'Image', type:'image' },
]);
const handleEdit = (row) => {
  Obj.value = { 
    ...row,
    dobDate: row.dobDate ? row.dobDate.slice(0, 10) : "",
  };
  if (Obj.value.Image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.Image = Obj.value.Image.replace(process.env.VUE_APP_API_URL, '');
  }
};

const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
 const  save =async() => {
      const fields = {
        Class: { value: Obj.value.ClassId, validators: [isRequired], },
        Section: { value: Obj.value.Section, validators: [isRequired], },
        Name: { value: Obj.value.Name, validators: [isRequired], },
        Photo: { value: Obj.value.Image, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/birthday${url}`, Obj.value)
          .then((response) => {
            loadData();
            reset();
            msgObj.value = { msg: `Birthday ${msg} Successfuly`, role: "success", show: true, };
            console.log(response);
          })
          .catch((error) => { console.log(error); });
      }
    }

const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  try {
        let uploadResult;
console.log(Obj.value.captureConsent)
        if (Obj.value.captureConsent === true) {
    const formData = new FormData();
    formData.append("image_file", file);
    formData.append("size", "auto");

    const response = await axios.post("https://api.remove.bg/v1.0/removebg", formData, {
      headers: {
        "X-Api-Key": "jfFAD9V8Kre3iCF53sLtm3aQ",
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
      validateStatus: () => true,
    });


    if (response.status === 200) {
      // ✅ Remove.bg successful → validate and upload
      const blobFile = new File([response.data], file.name, { type: file.type });
      uploadResult = await handleFileUploadImg(blobFile);
    } 
  }
    else {
      // ⚠️ Remove.bg failed → upload original file
      uploadResult = await handleFileUploadImg(file);
    }


    if (!uploadResult.valid && uploadResult.message) {
      msgObj.value = { msg: uploadResult.message, role: "danger", show: true };
      return;
    }

    if (uploadResult.file) {
      Obj.value.Image = uploadResult.file;
    }
  event.target.value = null;
  } catch (error) {
    console.error("Upload failed:", error);
  }
};

    const reset =async () => {
      Obj.value = { ClassId: "", Section: "", Name: "", dobDate: new Date().toISOString().slice(0, 10), Description: "", Image: "", };
      msgObj.value = { msg: "", role: "", show: false, };
       errors.value ={};
    }
    const progress = ref(0)
    const loadData =async () =>{
       let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/birthday/all') .then((response) => { rows.value = response.data.map((item, i) => ({ 
        ...item, Sno: i + 1, Date:formatDate(item.dobDate), Image:item.Image,
        Class: `${clsList.value.find(c => c._id === item.ClassId)?.name || ''}${clsList.value.find(c => c._id === item.ClassId)?.name ? (secList.value.find(s => s._id === item.Section)?.Name ? ' (' + secList.value.find(s => s._id === item.Section)?.Name + ')' : '') : ''}` }));
        progress.value = 0
          clearInterval(progressInterval)
         });
    }
    const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
   const delRecord =async () => {
      await api.delete(`/birthday/${delObj.value._id}`)
        .then(() => {
          loadData();
           delObj.value = {};
          msgObj.value = { msg: "Birthday Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    const getUrl = (img) => {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;
      return process.env.VUE_APP_API_URL + imgUrl;
    }
    onMounted(() => { loadData() })
</script>
